<template>
  <http-put-button
    v-bind="$props"
    v-on="$listeners"
    :href="value ? `/api/metadata/tenant/${value.id}` : null"
    version="v2"
    @http4xx="onError"
  >
  </http-put-button>
</template>

<i18n>
{
    "en": {
        "putTenantButton.errorMessage": "There was an error encountered while updating this tenant. If everything looks right please contact support so we can help you :)"
    }
}
</i18n>

<script>
import { toastError } from "@/components/Common/Toast.vue";
import HttpPutButton from "@/components/Common/HttpPutButton.vue";

export default {
  components: { HttpPutButton },
  props: { ...HttpPutButton.props },
  methods: {
    onError() {
      toastError(this.$t('putTenantButton.errorMessage'));
    },
  },
};
</script>